var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_427_11262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8045 15.815L11.2545 11.265C12.1359 10.1764 12.6665 8.79305 12.6665 7.28641C12.6665 3.79444 9.82522 0.953125 6.33325 0.953125C2.84128 0.953125 0 3.79441 0 7.28638C0 10.7783 2.84132 13.6197 6.33328 13.6197C7.83992 13.6197 9.22325 13.089 10.3119 12.2077L14.8619 16.7576C14.9919 16.8876 15.1625 16.953 15.3332 16.953C15.5039 16.953 15.6745 16.8876 15.8045 16.7576C16.0652 16.497 16.0652 16.0756 15.8045 15.815ZM6.33328 12.2863C3.57597 12.2863 1.33333 10.0437 1.33333 7.28638C1.33333 4.52906 3.57597 2.28642 6.33328 2.28642C9.0906 2.28642 11.3332 4.52906 11.3332 7.28638C11.3332 10.0437 9.09057 12.2863 6.33328 12.2863Z",
    fill: "#A0A0A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_427_11262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.953125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.68e679b8f6aa830826d7a725b2ba4d3c.svg";
export { ForwardRef as ReactComponent };